// export default function Dependent_addition_ops1_Edit() {
//   return (
//     <>
//       <h2>ops1 edit can be done here....</h2>
//     </>
//   );
// }
import { setAppError } from "../../../../store/userSlice";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { useNavigate } from "react-router-dom";
import Reject_PopUp from "./reject_PopUp";

export default function Dependent_addition_ops1_Edit({
  details,
  setTrigger,
  trigger,
  setIndex,
}) {
  const [DependentType, setDependentType] = useState("ADD DEPENDENTS");
  const handleDependentSelect = (data) => {
    setDependentType(data);
  };
  const token = localStorage.getItem("nodeToken");
  const [dependentData, setDependentData] = useState();

  const getDetails = async () => {
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/dependentDetails/${details.Employee_unique_id}/OPS1`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setDependentData(response.data.data);
      }
    } catch (error) {
      console.log("error to be seen here....", error);
    }
  };
  useEffect(() => {
    getDetails();
  }, [details]);
  const [inputList, setInputList] = useState([
    {
      sNo: "1",
      dependentName: "",
      dob: "",
      nationality: "",
      iqamaNumber: "",
      relation: "",
      gender: "",
      amount: "",
      Master_id: "",
      Employee_unique_id: "",
      status: "",
    },
  ]);

  const handleinputchange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleaddclick = () => {
    setInputList([
      ...inputList,
      {
        sNo: inputList.length + 1,
        dependentName: "",
        dob: "",
        nationality: dependentData && dependentData[0].nationality,
        iqamaNumber: "",
        relation: "",
        gender: "",
        insurance_class: "",
        amount: "",
        Master_id: "",
        Employee_unique_id: parseInt(details.Employee_unique_id),
      },
    ]);
  };

  useEffect(() => {
    setInputList((prevInputList) => {
      if (dependentData?.length === 0) {
        return prevInputList; // No change if dependentData is empty
      }

      return dependentData?.map((details, i) => ({
        sNo: i + 1,
        dependentName: details.dependent_name,
        nationality: details.nationality,
        iqamaNumber: details.dependent_iqama_number,
        relation: details.dependent_relation,
        insurance_class: details.insurance_class,
        gender: details.gender,
        dob: details.dependent_dob,
        Master_id: details.Master_id,
        amount: details.amount,
        Employee_unique_id: parseInt(details.Employee_Unique_Id),
        status: "FINANCE APPROVAL PENDING",
      }));
    });
  }, [dependentData]);

  const dispatch = useDispatch();

  const [accounts, setAccounts] = useState({
    CLIENT_EXPENSE: "",
    EMPLOYEE_EXPENSE: "",
    SLA: "",
  });

  useEffect(() => {
    if (dependentData && dependentData[0]) {
      setAccounts({
        CLIENT_EXPENSE: dependentData[0].client_expense || "",
        EMPLOYEE_EXPENSE: dependentData[0].employee_expense || "",
        SLA: dependentData[0].SLA || "",
      });
    }
  }, [dependentData]);
  

  const handleAccountChange = (e) => {
    const { name, value } = e.target;
    setAccounts((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();
  console.log(
    "inputList......dependentData to be seen",
    dependentData,
    inputList
  );
  const onSubmit = async () => {
    try {
      const reqObject = {
        inputList: inputList,
        type: DependentType,
        employee_expense:
          accounts.EMPLOYEE_EXPENSE === "" ? null : accounts.EMPLOYEE_EXPENSE,
        client_expense:
          accounts.CLIENT_EXPENSE === "" ? null : accounts.CLIENT_EXPENSE,
        SLA: accounts.SLA === "" ? null : accounts.SLA,
        Insurance_Flow_Type: "FINANCE",
      };
      console.log(".........req........", reqObject);
      const response = await nodeinstance.post(
        "/insurance-dependent/addDependentDetails",
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setTrigger(!trigger);
        navigate("/dashboard/dependent-addition");
      }
      console.log("Submit Data to be seen here.....", inputList, DependentType);
    } catch (error) {
      console.log("error to be seen here....", error);
    }
  };
  const [onReject, setOnReject] = useState(false);

  const handleRejectClick = () => {
    setOnReject(true);
  };
  console.log(".........details to be printed here.....", dependentData);

  const downloadPaymentReceipt = async (value) => {
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/downloadZip/${dependentData && dependentData[0]?.Employee_Unique_Id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      if (response.status === 200) {
        // const blob = await response.blob();
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Dependent_Documents.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
    return;
  };

  function formatDate(dateString) {
    if (!dateString) {
      return "N/A";
    }

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "N/A"; // Check if the date is invalid
    }

    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    const formattedDate = `${day}-${monthNames[monthIndex]}-${year}`;
    return formattedDate;
  }

  return (
    <div className="mt-5">
      <div className="mt-4">
        <p className="text-xl font-semibold">EMPLOYEE DETAILS:</p>
        <div className="flex justify-between ">
          <div className="  w-[49.8%] font-medium">
            <div className=" text-balck text-xl flex mt-1 ">
              <p className="bg-[#4F81BD]  w-[50%] p-1">EMPLOYEE NAME</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.employee_name}
              </p>
            </div>

            <div className=" text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">DOB</p>
              <p className="bg-white  w-[50%] text-center">
                {formatDate(dependentData && dependentData[0]?.date_of_birth)}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">KSA ARRIVAL DATE:</p>
              <p className="bg-white  w-[50%] text-center">
                {formatDate(dependentData && dependentData[0].ksa_arrival_date)}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">NATIONALITY:</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.nationality}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">IQAMA NUMBER:</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.iqama_number}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">PASSPORT NUMBER:</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.passport_number}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">CLIENT NAME</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.client_name}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1 ">TOTAL SALARY</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0].total_salary}
              </p>
            </div>
          </div>
          <div className="  w-[49.8%] font-medium">
            <div className=" text-balck text-xl flex mt-1 ">
              <p className="bg-[#4F81BD]  w-[50%] p-1">SLA EMP ID:</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.emp_id}
              </p>
            </div>

            <div className=" text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">ACTUAL PROFESSION:</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.actual_profession}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">BORDER NUMBER:</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.border_number}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">CURRENT SPONSOR:</p>
              <p className="bg-white  w-[50%] text-center">Auto</p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">IQAMA EXPIRY DATE:</p>
              <p className="bg-white  w-[50%] text-center">
                {formatDate(
                  dependentData && dependentData[0]?.iqama_expiry_date_g
                )}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">PASSPORT EXPIRY DATE:</p>
              <p className="bg-white  w-[50%] text-center">
                {formatDate(
                  dependentData && dependentData[0]?.passport_expiry_date
                )}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">PROJECT NAME:</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.project}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1 ">INSURANCE CLASS:</p>
              <p className="bg-white  w-[50%] text-center">
                {dependentData && dependentData[0]?.insurance_class}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* buttons */}
      <div className="flex justify-center mt-8 gap-x-10 font-semibold">
        <label className="flex gap-x-1">
          <input
            type="radio"
            name="selection"
            onChange={() => {
              handleDependentSelect("UPGRADE");
            }}
            disabled
          />
          <p>UPGRADE</p>
        </label>

        <label className="flex gap-x-1">
          <input
            type="radio"
            name="selection"
            defaultChecked
            onChange={() => {
              handleDependentSelect("ADD DEPENDENTS");
            }}
            disabled
          />
          <p>ADD DEPENDENTS</p>
        </label>
      </div>

      {/* dependent details */}

      <div className="mt-4 min-h-[120px] max-h-[250px] overflow-y-auto overflow-x-hidden">
        <p className="font-semibold text-xl ">DEPENDENTS DETAILS:</p>
        {/* <button onClick={handleaddclick} disabled={DependentType === "UPGRADE"}>
          Add
        </button> */}
        <table className="mt-4 border-2 border-white ">
          <tr className="  bg-black text-white p-2 border border-white">
            <th className=" px-10 border border-white">S.NO</th>
            <th className="px-10 border border-white">DEPENDENT NAME</th>
            <th className="px-10 border border-white">DATE OF BIRTH</th>
            <th className="px-10 border border-white">NATIONALITY</th>
            <th className="px-10 border border-white">IQAMA NUMBER</th>
            <th className="px-10 border border-white">RELATION</th>
            <th className="px-10 border border-white text-nowrap">
              INSURANCE CLASS
            </th>
            <th className="px-10 border border-white">GENDER</th>
            <th className="px-10 border border-white">AMOUNT</th>
          </tr>

          {inputList?.map((x, i) => {
            return (
              <tr key={i}>
                <td className=" border border-white text-center">{x.sNo}</td>
                <td className=" border border-white text-center">
                  <input
                    type="text"
                    className="outline-none text-center"
                    name="dependentName"
                    value={x.dependentName}
                    onChange={(e) => handleinputchange(e, i)}
                    disabled
                  />
                </td>
                <td className=" border border-white text-center">
                  <input
                    type="date"
                    className="outline-none text-center"
                    name="dob"
                    value={
                      x.dob
                        ? new Date(x.dob).toISOString().split("T")[0]
                        : "----"
                    }
                    onChange={(e) => handleinputchange(e, i)}
                    // disabled={x.dob != ""}
                    disabled
                  />
                </td>
                <td className=" border border-white text-center">
                  <input
                    type="text"
                    className="outline-none text-center"
                    name="nationality"
                    value={x.nationality}
                    onChange={(e) => handleinputchange(e, i)}
                    disabled
                  />
                </td>
                <td className="border border-white text-center">
                  <input
                    type="text"
                    className="outline-none text-center"
                    name="iqamaNumber"
                    value={x.iqamaNumber}
                    onChange={(e) => handleinputchange(e, i)}
                    // disabled={x.iqamaNumber != ""}
                    disabled
                  />
                </td>
                <td className=" border border-white text-center">
                  <select
                    className="text-center"
                    name="relation"
                    onChange={(e) => handleinputchange(e, i)}
                    value={x.relation}
                    disabled
                  >
                    <option>WIFE</option>
                    <option>SON</option>
                    <option>DAUGHTER</option>
                    <option>MOTHER</option>
                    <option>FATHER</option>
                  </select>
                </td>
                <td className="border border-white text-center">
                  <input
                    type="text"
                    className="outline-none text-center"
                    name="insurance_class"
                    value={x.insurance_class}
                    onChange={(e) => handleinputchange(e, i)}
                    disabled
                  />
                </td>
                <td className=" border border-white text-center">
                  <select
                    className="text-center"
                    name="gender"
                    onChange={(e) => handleinputchange(e, i)}
                    value={x.gender}
                    disabled
                  >
                    <option>Male</option>
                    <option>Female</option>
                  </select>
                </td>
                <td className=" border border-white text-center">
                  <input
                    type="number"
                    className="outline-none text-center"
                    name="amount"
                    value={x.amount}
                    onChange={(e) => handleinputchange(e, i)}
                    disabled
                  />
                </td>
              </tr>
            );
          })}
        </table>
      </div>

      {/* for accounts */}

      <div className="mt-10">
        <p className="text-xl font-semibold">FOR ACCOUNTS:</p>
        <table className="border-2 border-gray w-[100%] mt-2">
          <tr>
            <td className="px-4 py-4 border border-gray font-semibold">
              CLIENT EXPENSE:
            </td>
            <td className="px-4 py-4 border border-gray">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="CLIENT_EXPENSE"
                  value="INVOICE UPFRONT PAYMENT"
                  checked={accounts.CLIENT_EXPENSE === "INVOICE UPFRONT PAYMENT"}
                  onChange={(e) => {
                    handleAccountChange(e);
                  }}
                  disabled
                />
                <p>INVOICE UPFRONT PAYMENT</p>
              </label>
            </td>
            <td className="px-4 py-4 border border-gray">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="CLIENT_EXPENSE"
                  value="INVOICE LATER PAYMENT"
                  checked={accounts.CLIENT_EXPENSE === "INVOICE LATER PAYMENT"}
                  onChange={(e) => handleAccountChange(e)} // Adjusted to pass the event
                  disabled
                />
                <p>INVOICE LATER PAYMENT</p>
              </label>
            </td>
            <td className="px-4 py-4 border border-gray ">
              <label className="flex  gap-x-2 w-full">
                <p>SAR/</p>
                <input
                  type="number"
                  className="w-full"
                  name="CLIENT_EXPENSE"
                  value={accounts.CLIENT_EXPENSE}
                  onChange={(e) => {
                    handleAccountChange(e);
                  }}
                  disabled
                />
              </label>
            </td>
          </tr>

          <tr>
            <td className="px-4 border border-gray font-semibold">
              EMPLOYEE EXPENSE:
            </td>
            <td className="px-4 border border-gray">
              <label className="flex gap-x-1">
                {/* <input type="radio" /> */}
                <input
                  type="radio"
                  name="EMPLOYEE_EXPENSE"
                  value="DEDUCTABLE FROM SALARY"
                  checked={accounts.EMPLOYEE_EXPENSE === "DEDUCTABLE FROM SALARY"}
                  onChange={(e) => handleAccountChange(e)} // Adjusted to pass the event
                  disabled
                />
                <p>DEDUCTABLE FROM SALARY</p>
              </label>
            </td>
            <td className="px-4 border border-gray">
              <label className="flex gap-x-1">
                {/* <input type="radio" name="installment" /> */}
                <input
                  type="radio"
                  name="EMPLOYEE_EXPENSE"
                  value="INSTALLMENT-1"
                  checked={accounts.EMPLOYEE_EXPENSE === "INSTALLMENT-1"}
                  onChange={(e) => handleAccountChange(e)} // Adjusted to pass the event
                  disabled
                />
                <p>INSTALLMENT-1</p>
              </label>
              <label className="flex gap-x-1">
                {/* <input type="radio" name="installment" /> */}
                <input
                  type="radio"
                  name="EMPLOYEE_EXPENSE"
                  value="INSTALLMENT-2"
                  checked={accounts.EMPLOYEE_EXPENSE === "INSTALLMENT-2"}
                  onChange={(e) => handleAccountChange(e)} // Adjusted to pass the event
                  disabled
                />
                <p>INSTALLMENT-2</p>
              </label>
              <label className="flex gap-x-1">
                {/* <input type="radio" name="installment" /> */}
                <input
                  type="radio"
                  name="EMPLOYEE_EXPENSE"
                  value="INSTALLMENT-3"
                  checked={accounts.EMPLOYEE_EXPENSE === "INSTALLMENT-3"}
                  onChange={(e) => handleAccountChange(e)} // Adjusted to pass the event
                  disabled
                />
                <p>INSTALLMENT-3</p>
              </label>
            </td>
            <td className="px-4 py-7 border border-gray">
              <label className="flex  gap-x-2 w-full">
                <p>SAR/</p>
                {/* <input type="number" className="w-full" /> */}
                <input
                  type="number"
                  className="w-full"
                  name="EMPLOYEE_EXPENSE"
                  value={accounts.EMPLOYEE_EXPENSE}
                  onChange={(e) => {
                    handleAccountChange(e);
                  }}
                  disabled
                />
              </label>
            </td>
          </tr>

          <tr>
            <td className="px-4 py-4 border border-gray font-semibold">SLA:</td>
            <td className="px-4 py-4 border border-gray">
              <label className="flex gap-x-1">
                {/* <input type="radio" name="sla" /> */}
                <input
                  type="radio"
                  name="SLA"
                  value="INUCLUDE IN CHARGE"
                  checked={accounts.SLA === "INUCLUDE IN CHARGE"}
                  onChange={(e) => handleAccountChange(e)}
                  disabled
                />
                <p>INUCLUDE IN CHARGE </p>
              </label>
            </td>
            <td className="px-4 py-4 border border-gray">
              <label className="flex gap-x-1">
                {/* <input type="radio" name="sla" /> */}
                <input
                  type="radio"
                  name="SLA"
                  value="SLA EXPENSE"
                  checked={accounts.SLA === "SLA EXPENSE"}
                  onChange={(e) => handleAccountChange(e)}
                  disabled
                />
                <p>SLA EXPENSE</p>
              </label>
            </td>
            <td className="px-4 py-7 border border-gray ">
              <label className="flex w-full  gap-x-2">
                <p>SAR/</p>
                {/* <input type="number" className="w-full" /> */}
                <input
                  type="number"
                  className="w-full"
                  name="SLA"
                  onChange={(e) => {
                    handleAccountChange(e);
                  }}
                  value={accounts.SLA}
                  disabled
                />
              </label>
            </td>
          </tr>
        </table>
      </div>

      {/* buttons */}

      <div className="flex mt-3 justify-between">
        <button
          className="bg-black text-white px-10 rounded-md py-1 text-sm h-[38px]"
          onClick={() => {
            downloadPaymentReceipt();
          }}
        >
          VIEW SUPPORTING DOCUMENT
        </button>
        <div className="flex space-x-2">
          <button className="bg-black text-white px-10 rounded-md py-1 text-sm h-[38px]">
            EDIT
          </button>
          <button
            className="bg-black text-white px-10 rounded-md py-1 text-sm h-[38px]"
            onClick={() => {
              onSubmit();
            }}
          >
            SUBMIT
          </button>
          <button
            className="bg-red text-white px-10 rounded-md py-1 text-sm h-[38px]"
            onClick={() => {
              handleRejectClick();
            }}
          >
            REJECT
          </button>
        </div>
      </div>
      {onReject ? (
        <Reject_PopUp
          setOnReject={setOnReject}
          onReject={onReject}
          inputList={inputList}
          setTrigger={setTrigger}
          trigger={trigger}
          setIndex={setIndex}
        />
      ) : (
        ""
      )}
    </div>
  );
}
